import React from 'react';
import PropTypes from 'prop-types';
import PageTemplate from '../../templates/PageTemplate';
import Breadcrumbs from '../../atoms/Breadcrumbs';
// eslint-disable-next-line import/no-named-as-default
import OrderSummaries from '../../organisms/OrderSummaries';

export const OrderSummary = ({ history }) => (
  <React.Fragment>
    <PageTemplate title="Orders" />
    <Breadcrumbs currentRoute={history.location.pathname.substr(1)} />
    <OrderSummaries />
  </React.Fragment>
);

OrderSummary.propTypes = {
  history: PropTypes.instanceOf(Object),
};

OrderSummary.defaultProps = {
  history: PropTypes.func,
};



// WEBPACK FOOTER //
// src/components/pages/OrderSummary/index.jsx